<div
  class="bg-petro-n1 bottom-0 left-0 z-10 w-full p-24"
  [ngClass]="{ 'grid h-auto grid-cols-3 items-center': showFullFooter }"
  [class.fixed]="applyFixedFooterClass"
  [class.bg-petro-p1]="!loginSimplificationEnabled"
  [class.text-green]="!loginSimplificationEnabled"
>
  <div *ngIf="showFullFooter" class="justify-self-start">
    <a
      *ngIf="showBackToTownSq"
      [href]="loginLinks.backToTownSqLink"
      [class.new-primary-link]="loginSimplificationEnabled"
      >{{ 'LOGIN.BACK_TO_TOWNSQ' | translate }}</a
    >
  </div>

  <div class="justify-self-center">
    <a
      *ngIf="isTownSqBrazil && !loginSimplificationEnabled"
      target="_blank"
      [href]="loginLinks.helpCenterLink"
    >
      {{ 'LOGIN.ACCESS_HELP_CENTER' | translate }}
    </a>

    <a
      *ngIf="loginSimplificationEnabled && !isTownSqBrazil"
      class="new-primary-link"
      [href]="loginLinks.supportContactLink"
      [attr.target]="supportContactTarget"
      >{{ 'LOGIN.NEED_HELP' | translate }}</a
    >

    <a
      *ngIf="showRecoveryPassword"
      class="new-primary-link ml-24"
      (click)="goToUserRecoveryRoute.emit()"
      >{{ 'LOGIN.FORGOT_YOUR_PASSWORD_V2' | translate }}</a
    >
  </div>

  <div *ngIf="showFullFooter" class="flex gap-24 justify-self-end">
    <ng-container *ngIf="isTownSqBrazil; else isNotTownSqBrazil">
      <a class="new-primary-link" target="_blank" [href]="loginLinks.helpCenterLink">
        {{ 'LOGIN.ACCESS_HELP_CENTER' | translate }}
      </a>
      <a
        class="new-primary-link"
        [href]="loginLinks.supportContactLink"
        [attr.target]="supportContactTarget"
        >{{ 'LOGIN.NEED_HELP' | translate }}</a
      >
    </ng-container>

    <ng-template #isNotTownSqBrazil>
      <a
        [class.new-primary-link]="loginSimplificationEnabled"
        [href]="loginLinks.termsOfUseLink"
        target="_blank"
      >
        {{ 'LOGIN.TERMS_OF_USE' | translate }}
      </a>
      <a
        [href]="loginLinks.privacyPolicyLink"
        [class.new-primary-link]="loginSimplificationEnabled"
        target="_blank"
      >
        {{ 'LOGIN.PRIVACY_POLICE' | translate }}
      </a>
    </ng-template>
  </div>
</div>
